<app-change-course-header
  [heading]="'Dashboard'"
  [showChangeCourse]="true"
></app-change-course-header>
